import { Component, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { ModalController, AlertController, NavController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';

import { Project } from '../../models/Project';
import { ProjectService } from '../../providers/project-service/project-service';
import { InstitutionService } from 'src/app/providers/institution-service/institution-service';
import { Institution } from 'src/app/models/Institution';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { environment } from 'src/environments/environment';

import { load } from "@finapi/web-form";
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/providers/auth-service/auth-service';

@Component({
  selector: 'app-fast-connect',
  templateUrl: './fast-connect.page.html',
  styleUrls: ['./fast-connect.page.scss'],
  host: {
    'class': 'accent-page connect-page'
  }
})
export class FastConnectPage implements OnInit {

  initializing: boolean = true;
  project: Project;
  
  connectionStep: string = "init";
  searchLoading: boolean = false;
  search: string = "";
  institutionsSearch: Institution[];
  selectedInstitution: Institution = null;

  loadingWebform: boolean = false;
  webformId: string = "";
  webformUrl: string = "";
  safeWebformUrl: SafeResourceUrl = "";
  embedWebForm: boolean = environment.finAPIEmbedding;
  @ViewChild('webFormContainer') webformContainer: any;
  webformStatusInterval: any;
  webformStatus: string = "NOT_YET_OPENED";
  webformMessage: string = "";

  constructor(
    public auth: AuthService,
    public modalController: ModalController,
    public alertController: AlertController,
    public projectService: ProjectService,
    public institutionService: InstitutionService,
    private activatedRoute: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    private renderer: Renderer2,
    private http: HttpClient,
    private navCtrl: NavController) {}

  ngOnInit() {
    let projectId = this.activatedRoute.snapshot.paramMap.get('projectId');
    this.projectService.isReady().then(()=>{
        if(projectId){
          let currentProject = this.projectService.getCurrentProject();
          if(!currentProject || currentProject.id != projectId){
            this.projectService.setCurrentProject(projectId).then(()=>{
              this.project = this.projectService.getCurrentProject();
              this.initializing = false;
            }).catch((err)=>{
              console.log("Error setting current project: ", err);
              this.initializing = false;
              this.connectionStep = "noAccess";
            });
          } else {
            this.project = this.projectService.getCurrentProject();
            this.initializing = false;
          }
        } else {
          this.initializing = false;
          this.connectionStep = "noAccess";
        } 
    }); 
  }

  /*
    consent given
  */
  userConsented(){
    // get the get params
    let params = this.activatedRoute.snapshot.queryParams;

    // only continue if some params are set
    if (!params) {
      this.connectionStep = "search";
      return;
    }

    let iban = params.iban;
    if(!iban) iban = params.Iban;
    if(!iban) iban = params.IBAN;
    if(iban) iban = iban.replaceAll(/\s/g, '');

    let bic = params.bic;
    if(!bic) iban = params.Bic;
    if(!bic) iban = params.BIC;
    if(bic) bic = bic.replaceAll(/\s/g, '');

    let blz = params.blz;
    if(!blz) blz = params.Blz;
    if(!blz) blz = params.BLZ;
    if(blz) blz = blz.replaceAll(/\s/g, '');

    let bankname = params.bankname;
    if(!bankname) bankname = params.bank;
    if(!bankname) bankname = params.name;

    if (iban && iban != "") { // iban should be great for direct search
      this.connectionStep = "silentsearch";
      this.search = iban;
    } else if (bic && bic != "") { // bic should be great for direct search
      this.connectionStep = "silentsearch";
      this.search = bic;
    } else if (blz && blz != "") { // blz should be great for direct search
      this.connectionStep = "silentsearch";
      this.search = blz;
    } else if(bankname) {
      this.connectionStep = "silentsearch";
      this.search = bankname;
    } else {
      this.connectionStep = "search";
    }

    if(this.search) {
      this.handleBankSearch({ target: { value: this.search } }).then((result) => {
        if(result){
          if(this.institutionsSearch.length == 1){
            this.selectBank(this.institutionsSearch[0]);
          }
        } else {
          this.connectionStep = "search";
        }
      });
    }

  }

  /*
    * Search for a bank
  */
  gotoSearch(ev) {
    if(ev){
      ev.preventDefault();
    }
    this.search = "";
    this.institutionsSearch = [];
    this.connectionStep = "search";
  }
  handleBankSearch(event) {
    return new Promise((resolve, reject) => {
      let val = event.target.value;
      if(val.length > 2) {
        this.searchLoading = true;
        this.institutionService.searchInstitution(val).then((result) => {
          this.institutionsSearch = result.banks;
          this.searchLoading = false;
          resolve(true);
        }).catch((err) => {
          this.searchLoading = false;
          resolve(false);
        });
      } else {
        resolve(false);
      }
    });
  }

  /*
    Select a bank
  */

  async selectBank(item: Institution) {
    this.selectedInstitution = item;
    this.connectionStep = "select";

    let projectId = this.projectService.getCurrentProject().id;
    let institutionId = this.selectedInstitution.id;

    // prepare webform, so it is ready when the user clicks on connect
      this.loadingWebform = true;
      let webform = await this.institutionService.createImportRequest(institutionId, projectId);

      if(webform.id) {
        this.loadingWebform = false;
        this.webformId = webform.id;
        this.webformUrl = webform.url; 
        this.safeWebformUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(this.webformUrl);       

        if(this.embedWebForm){
          this.createWebForm();
        } 
      } else {
        // something went wrong
      }


  }

  /*
    Start Connection
  */
  async startConnection() {
    
    this.connectionStep = (this.embedWebForm ? "webform" : "webform-tab");

    this.webformStatusInterval = setInterval(this.webformIntervalHandler.bind(this), 3000);

    if(!this.embedWebForm) return false;

  }

  webformStepMessage(){
    if(this.loadingWebform){
      return "Es öffnet sich ein Formular, um die Verbindung herzustellen...";
    } else {
      if(this.connectionStep == "webform-tab"){
        if(this.webformStatus == "NOT_YET_OPENED"){
         return "Es öffnet sich gleich ein neuer Tab in deinem Browser. Folge den Anweisungen.";
        } else if(this.webformStatus == "IN_PROGRESS"){
          return "Folge den Anweisungen im neuen Tab und schließe dort den Prozess ab.";
        }
      }
    }
  }

  webformIntervalHandler(){
    this.institutionService.getImportStatus(this.selectedInstitution.id, this.project.id ,this.webformId).then((res) => {
      
      if(res.code){
        this.webformStatus = "ERROR";
        this.webformMessage = res.code;
        this.cancelWebform();
        return false;
      }
      this.webformStatus = res.status;

      if(this.webformStatus == "COMPLETED_WITH_ERROR"){
        this.webformMessage = res.payload.errorMessage;
        this.cancelWebform();
        return false;
      }

      if(this.webformStatus == "ABORTED"){
        this.cancelWebform();
        return false;   
      }

      if(this.webformStatus == "COMPLETED"){
        this.webformMessage = "Die Verbindung wurde erfolgreich hergestellt.";
        this.successfulWebform();
        return false;
      }

    });
  }

  cancelWebform(){
    clearInterval(this.webformStatusInterval);
    this.webformId = "";
    this.webformUrl = "";
    if(this.webformStatus == "ERROR" || this.webformStatus == "COMPLETED_WITH_ERROR"){
      this.connectionStep = "error";
    } else {
      this.selectBank(this.selectedInstitution);
    }
  }

  successfulWebform(){
    clearInterval(this.webformStatusInterval);
    this.webformId = "";
    this.webformUrl = "";
    this.connectionStep = "success"; 
  }

  closeWindow(){
    // @ts-ignore
    window.close('','_parent','');
  }

  /*
    EMBEDDED WEBFORM
  */
  createWebForm() {
    return new Promise( async (resolve, reject) => {
    let target = this.webformContainer.nativeElement;
    if (!target) return;

    let webformCSS = await this.http.get('/assets/webform.css', { responseType: 'text' }).toPromise();

      load(
        target,
        {
          token: this.webformId,
          targetUrl: environment.finapiWebformBase,
          layoutConfig: "xs",
          
        },
        {
          onComplete: () => {
            this.webformIntervalHandler();
            this.projectService.triggerAction(this.project,'import');
          },
          onFail: () => {
            this.webformIntervalHandler();
          },
          onAbort: () => {
            this.closeWindow();
          },
          onLoadError: () => {
            this.webformIntervalHandler();
            reject({ error: "loadError"});
          },
          onLoaded: () => {
            const style = this.renderer.createElement('style');
            style.innerText = webformCSS;
            this.renderer.appendChild(this.webformContainer.nativeElement.getElementsByTagName('finapi-webform2-webcomponent')[0].shadowRoot, style);
     
              resolve(true);
          }
        }
      );

    });

  }

}
